export default "<div id=\"hc-donut\"></div>\n";